import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import * as queryString from 'query-string';
import * as actions from '../../actions/club-actions';
import { getNewClubPath, isActive } from '../../utils/clubs';
import ClubAddMembersSearch from '../../components/Clubs/ClubAddMembersSearch';
import ClubAddMembersForm from '../../components/Clubs/ClubAddMembersForm';
import { ClubInactivePopup, MemberLimitPopup, AddMemberSuccessPopup, MemberPowerLimitPopup } from '../../components/Clubs/Popups';

import { playerProfile } from '../../api';

import InviteMembersModal from '../../components/Modals/InviteMembersModal';
import requireAuth from '../../components/hocs/requireAuth';
import requireOnboarding from '../../components/hocs/requireOnboarding';
import withStatsig from '../../components/hocs/withStatsig';
import styles from './clubAddMembers.scss';
import { getApiAxiosInstance } from '../../utils/network';
import { isValidClassYearId } from '../../utils/constants';
import { showSplash } from '../../actions/splash-actions';
import config from '../../../config';

class ClubAddMembersPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            submitting: false,
            showInactivePopup: false,
            showMemberLimitPopup: false,
            showMemberPowerLimitPopup: false,
            showSuccessPopup: false,
            invitePlayers: false,
            selectedPlayer: null,
            flowType: 'search',
            searchButtonText: 'Next',
            showValidation: false,
            showInviteMembersModal: false,
        };

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handlePlayerSubmit = this.handlePlayerSubmit.bind(this);
        this.toggleForm = this.toggleForm.bind(this);
        this.handlePlayerSelect = this.handlePlayerSelect.bind(this);
        this.getFormApi = this.getFormApi.bind(this);
        this.clearPlayer = this.clearPlayer.bind(this);
        this.isPlayerSelectedAndClaimed = this.isPlayerSelectedAndClaimed.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.inviteMembers = this.inviteMembers.bind(this);
        this.onInvitePlayersClick = this.onInvitePlayersClick.bind(this);
        this.closeInviteMembersModal = this.closeInviteMembersModal.bind(this);
    }

    async componentDidMount() {
        const parsed = queryString.parse(this.props.location.search);
        if (parsed.playerId && parseInt(parsed.playerId) > 0 && !this.state.selectedPlayer) {
            const axiosInstance = getApiAxiosInstance();
            const playerResult = await playerProfile(axiosInstance, parseInt(parsed.playerId));
            this.setState({
                selectedPlayer: playerResult.data,
            });
            this.toggleForm();
        }
        if (!this.props.club.clubDetails) {
            this.props.setClubId(this.props.match.params.clubId);
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const { clubDetails } = nextProps.club;
        const { clubType, clubId } = this.props.match.params;
        const currentMemberRole = (clubDetails?.currentMember?.role);
        const isAdminOrOwner = (currentMemberRole === 'Owner' || currentMemberRole === 'Admin');
        // check if admin
        if (clubDetails && !isAdminOrOwner) {
            // eslint-disable-next-line no-restricted-globals
            location.href = `/${clubType}/${clubId}`;
        }
    }

    onInvitePlayersClick() {
        this.setState({
            showInviteMembersModal: true,
        });
    }

    getFormApi(formApi) {
        if (this.state.selectedPlayer) {
            const player = this.state.selectedPlayer;
            formApi.setAllValues({
                firstName: player.firstName,
                lastName: player.lastName,
                gender: player.gender && (player.gender === 'Male' ? 'M' : 'F'),
            });
        }
        this.formApi = formApi;
    }

    toggleForm() {
        const { flowType } = this.state;
        if (flowType === 'search') {
            this.setState({ flowType: 'form' });
        } else {
            this.setState({
                flowType: 'search',
                showValidation: false,
            });
        }
        // set url to only pathname if there was a playerId provided.
        const parsed = queryString.parse(this.props.location.search);
        if (parsed.playerId) {
            this.props.history.replace(this.props.location.pathname);
        }
    }

    async inviteMembers(members) {
        const player = this.state.selectedPlayer;
        const membersToInvite = [];
        members.forEach(member => {
            if (member.email) {
                membersToInvite.push({
                    ...member,
                    playerId: player ? player.id : null,
                });
            } else if (member.memberId) {
                membersToInvite.push({
                    memberId: member.memberId,
                });
            }
        });
        await this.props.inviteMembersToClub(membersToInvite);
        this.closeInviteMembersModal();
        const splashText = 'Invite Email Sent!';

        const { clubDetails } = this.props.club;
        const newClubPath = getNewClubPath(clubDetails?.tierType?.id);
        const isClubRedirectEnabled = this.props.checkGate && this.props.featureGates
            ? this.props.checkGate(this.props.featureGates.CLUB_LINKS_REDIRECT)
            : false;

        if (isClubRedirectEnabled) {
            this.props.showSplash();
            window.location.href = `${config.nextAppHost}/${newClubPath}/${clubDetails.id}`;
            return;
        }

        this.props.history.push({
            pathname: `/clubs/${this.props.match.params.clubId}`,
            state: {
                adminSplash: splashText,
                showAdminSplash: true,
            },
        });
    }

    closeInviteMembersModal() {
        this.setState({
            showInviteMembersModal: false,
        });
    }

    clearPlayer() {
        if (this.state.selectedPlayer) {
            this.setState({ selectedPlayer: null });
            // set url to only pathname if there was a playerId provided.
            const parsed = queryString.parse(this.props.location.search);
            if (parsed.playerId) {
                this.props.history.replace(this.props.location.pathname);
            }
        }
    }

    isPlayerSelectedAndClaimed() {
        return this.state.selectedPlayer && this.state.selectedPlayer.claimed;
    }

    handlePlayerSelect(player) {
        this.setState({
            selectedPlayer: player,
        });
    }

    handlePlayerSubmit() {
        this.toggleForm();
    }

    handleCancel() {
        const { clubDetails } = this.props.club;
        const newClubPath = getNewClubPath(clubDetails?.tierType?.id);
        const isClubRedirectEnabled = this.props.checkGate && this.props.featureGates
            ? this.props.checkGate(this.props.featureGates.CLUB_LINKS_REDIRECT)
            : false;
        if (clubDetails) {
            if (isClubRedirectEnabled) {
                this.props.showSplash();
                window.location.href = `${config.nextAppHost}/${newClubPath}/${clubDetails.id}`;
                return;
            }
            this.props.history.push(`/clubs/${clubDetails.id}`);
        } else {
            this.props.history.goBack();
        }
    }

    async addPlayerToRoster(player, classYearId, gradYear, isRostersRolloutEnabled) {
        if (!player?.id) {
            return;
        }

        if (isRostersRolloutEnabled && classYearId) {
            // Validate classYearId
            if (!isValidClassYearId(classYearId)) {
                throw new Error(`Invalid classYearId: ${classYearId}. Must be between 1 and 6.`);
            }

            // Use the addPlayerToRoster action which handles optimistic updates with new API
            // The action will handle rosterId fetching internally via getRosterId helper
            await this.props.addPlayerToRoster(
                {
                    playerId: player.id,
                    classYearId,
                },
                this.props.checkGate,
                this.props.featureGates,
            );
        } else if (!isRostersRolloutEnabled && gradYear) {
            // Use old API endpoint when rosters_rollout is disabled
            await this.props.addPlayerToRoster(
                {
                    playerId: player.id,
                    gradYear,
                },
                this.props.checkGate,
                this.props.featureGates,
            );
        } else {
            // If neither condition is met, player is not added to roster (intentional)
            // This can happen when:
            // - rosters_rollout is enabled but no classYearId is provided
            // - rosters_rollout is disabled but no gradYear is provided
        }
    }

    isAtMemberLimit(clubDetails, role) {
        switch (role) {
            case 'member':
                return clubDetails.availableMemberSlots >= 0 && clubDetails.availableMemberSlots < 1;
            case 'admin':
                return clubDetails.availableAdminSlots >= 0 && clubDetails.availableAdminSlots < 1;
            case 'owner':
                return clubDetails.availableOwnerSlots >= 0 && clubDetails.availableOwnerSlots < 1;
            default:
                break;
        }
    }

    async handleSubmit(values) {
        this.setState({
            submitting: true,
            showValidation: true,
        });
        const { clubDetails } = this.props.club;
        // make sure this club is active
        if (!isActive(clubDetails)) {
            this.setState({ showInactivePopup: true, submitting: false });
            return;
        }
        // check if there are any available member slots
        if (this.isAtMemberLimit(clubDetails, values.role)) {
            this.setState({ showMemberLimitPopup: true, submitting: false, selectedRole: values.role });
            return;
        }
        // check if there are any available member slots for power is selected
        if (values.isPower === true) {
            if (clubDetails.maxPowerUsers - clubDetails.currentPowerUsers <= 0) {
                this.setState({ showMemberPowerLimitPopup: true, submitting: false });
                return;
            }
        }
        const player = this.state.selectedPlayer;
        const isRostersRolloutEnabled = this.props.checkGate && this.props.featureGates
            ? this.props.checkGate(this.props.featureGates.ROSTERS_ROLLOUT)
            : false;

        try {
            if (clubDetails?.tierType?.isHighSchool && !this.isPlayerSelectedAndClaimed()) {
                const membersToInvite = [];
                if (values.email) {
                    membersToInvite.push({
                        email: values.email,
                        playerId: player ? player.id : null,
                    });
                }
                this.props.inviteMembersToClub(membersToInvite);
                this.setState({
                    invitePlayers: true,
                });
            } else {
                // Extract classYearId if rosters_rollout is enabled, otherwise use gradYear
                const memberData = {
                    ...values,
                    playerId: player ? player.id : null,
                };

                // Remove classYearId/gradYear from memberData as they're handled separately
                const classYearId = isRostersRolloutEnabled && values.classYearId ? parseInt(values.classYearId) : null;
                const gradYear = !isRostersRolloutEnabled && values.gradYear ? parseInt(values.gradYear) : null;

                if (isRostersRolloutEnabled) {
                    delete memberData.classYearId;
                } else {
                    delete memberData.gradYear;
                }

                await this.props.addMemberToClub(memberData);

                // Add player to roster - use new API if rosters_rollout is enabled, otherwise use old API
                await this.addPlayerToRoster(player, classYearId, gradYear, isRostersRolloutEnabled);
            }
            this.setState({
                submitting: false,
                showSuccessPopup: true,
                showValidation: false,
            });
        } catch (err) {
            this.setState({
                submitting: false,
            });
        }
    }

    render() {
        const { clubDetails } = this.props.club;
        const { flowType } = this.state;
        const isHighSchool = clubDetails?.tierType?.isHighSchool;
        const title = isHighSchool ? 'Add Players' : 'Add Members';
        const showGradYearField = isHighSchool;
        const newClubPath = getNewClubPath(clubDetails?.tierType?.id);
        const isClubRedirectEnabled = this.props.checkGate && this.props.featureGates
            ? this.props.checkGate(this.props.featureGates.CLUB_LINKS_REDIRECT)
            : false;
        return (
            <>
                {clubDetails && (
                    <div>
                        <div className={`${styles.addMembers} ${styles.section}`}>
                            <div className={`container h2 bg-transparent`}>
                                <div className={`text-center ${styles.clubName}`} data-testid="club-add-members.page.club-name">
                                    {clubDetails.name}
                                </div>
                                <h2 className="text-center" data-testid="club-add-members.page.title">{title}</h2>
                                {/* {description && <p>{description}</p>} */}
                            </div>
                            <div>
                                {flowType === 'search' ? (
                                    <>
                                        <ClubAddMembersSearch
                                            selectedPlayer={this.state.selectedPlayer}
                                            handlePlayerSelect={this.handlePlayerSelect}
                                            handlePlayerSubmit={this.handlePlayerSubmit}
                                            handleCancel={this.handleCancel}
                                            clearPlayer={this.clearPlayer}
                                            toggleForm={this.toggleForm}
                                            isHighSchool={isHighSchool}
                                            onInvitePlayersClick={this.onInvitePlayersClick}
                                            buttonText={this.state.searchButtonText}
                                            clubId={clubDetails.id}
                                            clubLocation={clubDetails.location}
                                        />
                                    </>
                                ) : (
                                    <>
                                        <ClubAddMembersForm
                                            showMemberInfo={!this.isPlayerSelectedAndClaimed()}
                                            handleSubmit={this.handleSubmit}
                                            inviteMembers={this.inviteMembers}
                                            toggleForm={this.toggleForm}
                                            getFormApi={this.getFormApi}
                                            submitting={this.state.submitting}
                                            validationMessage={this.state.showValidation ? this.props.club.validationMessage : ''}
                                            showPowerInput={clubDetails?.tierType?.name === 'Enterprise'}
                                            showMemberTypeSelect={clubDetails?.tierType?.name === 'Enterprise'}
                                            showGradYear={showGradYearField}
                                            isHighSchool={isHighSchool}
                                            checkGate={this.props.checkGate}
                                            featureGates={this.props.featureGates}
                                        />
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                )}
                {clubDetails && (
                    <AddMemberSuccessPopup
                        show={this.state.showSuccessPopup}
                        confirm={() => {
                            this.setState({
                                showSuccessPopup: false,
                            });
                            this.clearPlayer();
                            this.toggleForm();
                        }}
                        close={async () => {
                            this.setState({
                                showSuccessPopup: false,
                            });
                            // Refresh the roster to ensure the newly added player is visible
                            // This ensures the roster count and player list are up-to-date when navigating
                            const isRostersRolloutEnabled = this.props.checkGate && this.props.featureGates
                                ? this.props.checkGate(this.props.featureGates.ROSTERS_ROLLOUT)
                                : false;
                            try {
                                // Refresh roster regardless of feature flag to ensure data is up-to-date
                                await this.props.getClubSchoolDetails(isRostersRolloutEnabled);
                            } catch (error) {
                                // eslint-disable-next-line no-console
                                console.warn('Failed to refresh roster before navigation:', error);
                            }
                            if (isClubRedirectEnabled) {
                                this.props.showSplash();
                                window.location.href = `${config.nextAppHost}/${newClubPath}/${this.props.match.params.clubId}`;
                                return;
                            }
                            this.props.history.push(`/clubs/${this.props.match.params.clubId}`);
                        }}
                        showPlayerMessage={clubDetails.tierType?.isHighSchool}
                        invitePlayers={this.state.invitePlayers}
                    />
                )}
                <ClubInactivePopup
                    show={this.state.showInactivePopup}
                    close={() => this.setState({ showInactivePopup: false })}
                    clubTierType={clubDetails?.tierType}
                    status={null}
                />
                <MemberLimitPopup
                    show={this.state.showMemberLimitPopup}
                    close={() => this.setState({ showMemberLimitPopup: false, selectedRole: null })}
                    memberRole={this.state.selectedRole}
                />
                {clubDetails && (
                    <MemberPowerLimitPopup
                        show={this.state.showMemberPowerLimitPopup}
                        maxPowerUsers={clubDetails?.maxPowerUsers}
                        close={() => this.setState({ showMemberPowerLimitPopup: false })}
                    />
                )}
                {this.state.showInviteMembersModal && (
                    <InviteMembersModal
                        title={`Invite Players to High School`}
                        onCloseClick={this.closeInviteMembersModal}
                        onActionClick={this.inviteMembers}
                    />
                )}
            </>
        );
    }
}

ClubAddMembersPage.propTypes = {
    location: PropTypes.shape({
        search: PropTypes.string.isRequired,
        pathname: PropTypes.string.isRequired,
    }).isRequired,
    match: PropTypes.shape({
        params: PropTypes.shape({
            clubId: PropTypes.string.isRequired,
            clubType: PropTypes.string.isRequired,
        }).isRequired,
    }).isRequired,
    history: PropTypes.shape({
        push: PropTypes.func.isRequired,
        replace: PropTypes.func.isRequired,
        goBack: PropTypes.func.isRequired,
    }).isRequired,
    club: PropTypes.shape({
        clubDetails: PropTypes.shape({
            id: PropTypes.string,
            name: PropTypes.string,
            location: PropTypes.string,
            tierType: PropTypes.shape({
                name: PropTypes.string,
                isHighSchool: PropTypes.bool,
            }),
            availableMemberSlots: PropTypes.number,
            availableAdminSlots: PropTypes.number,
            availableOwnerSlots: PropTypes.number,
            maxPowerUsers: PropTypes.number,
            currentPowerUsers: PropTypes.number,
            currentMember: PropTypes.shape({
                role: PropTypes.string,
            }),
        }),
        validationMessage: PropTypes.string,
    }).isRequired,
    setClubId: PropTypes.func.isRequired,
    addMemberToClub: PropTypes.func.isRequired,
    inviteMembersToClub: PropTypes.func.isRequired,
    addPlayerToRoster: PropTypes.func.isRequired,
};

function mapDispatchToProps(dispatch) {
    return {
        setClubId: (clubId) => {
            dispatch(actions.setClubId(clubId));
        },
        addMemberToClub: (values) => {
            return dispatch(actions.addMemberToClub(values));
        },
        inviteMembersToClub: (members) => dispatch(actions.inviteMembersToClub(members)),
        addPlayerToRoster: (playerData, checkGate, featureGates) => dispatch(actions.addPlayerToRoster(playerData, checkGate, featureGates)),
        getClubSchoolDetails: (useRostersApi) => {
            return dispatch(actions.getClubSchoolDetails(useRostersApi));
        },
        showSplash: () => {
            dispatch(showSplash());
        },
    };
}

function mapStateToProps({ auth, search, header, club }) {
    return { auth, search, header, club };
}

export default requireAuth(requireOnboarding(withStatsig(connect(mapStateToProps, mapDispatchToProps)(ClubAddMembersPage))));
